'use client'

import { memo } from 'react'

import Button from 'shared/ui/Button'

import styles from './DeliveryActionPanel.module.scss'

interface DeliveryActionPanelProps {
  hasSelection: boolean
  summaryText: string
  isChanged: boolean
  isLoading: boolean
  onClearSelection: () => void
  onOpenConfirmModal: () => void
}

const DeliveryActionPanel: React.FC<DeliveryActionPanelProps> = ({
  hasSelection,
  isChanged,
  isLoading,
  onClearSelection,
  onOpenConfirmModal
}) => {
  return (
    <div className={styles.deliverySlotSubmitWrapper}>
      <div className={styles.buttonsWrapper}>
        <Button variant='neutralText' onClick={onClearSelection}>
          Wyczyść
        </Button>
        <Button
          variant='primary'
          disabled={!isChanged || !hasSelection || isLoading}
          onClick={onOpenConfirmModal}
          loading={isLoading}
        >
          Zapisz rezerwacje
        </Button>
      </div>
    </div>
  )
}

export default memo(DeliveryActionPanel)
